module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lm-win",
    class: {
      'lm-win-max': _vm.win.maximized
    },
    style: (_vm.winStyle),
    on: {
      "mousedown": _vm.onFocus
    }
  }, [_c('div', {
    staticClass: "lm-title",
    on: {
      "mouseenter": _vm.showTitleTip,
      "mouseleave": _vm.hideTitleTip,
      "click": _vm.showTitleTip
    }
  }, [_c('div', {
    staticClass: "lm-title-text"
  }, [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('div', {
    staticClass: "lm-title-actions"
  }, [(_vm.win.lesson.liveUrl) ? _c('Button', {
    attrs: {
      "size": "small",
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onOpenExternal.apply(null, arguments)
      }
    }
  }, [_vm._v("新窗口打开")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipVisible),
      expression: "tipVisible"
    }],
    staticClass: "lm-title-tip",
    style: (_vm.tipStyle),
    on: {
      "mouseenter": _vm.showTitleTip,
      "mouseleave": _vm.hideTitleTip
    }
  }, [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('div', {
    staticClass: "lm-body",
    on: {
      "click": _vm.onBodyClick
    }
  }, [(_vm.win.playing) ? _c('video', {
    ref: "player",
    staticClass: "lm-video",
    attrs: {
      "autoplay": "",
      "muted": "",
      "playsinline": "",
      "controls": ""
    },
    domProps: {
      "muted": true
    }
  }) : _c('div', {
    staticClass: "lm-placeholder"
  }, [_vm._v("\n      " + _vm._s(_vm.placeholderText) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44f704ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lesson/LiveMonitorWindow.vue
// module id = 1770
// module chunks = 8